/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qk_HasInputs */

const en_qk_has = /** @type {(inputs: Qk_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`parent, children, assignee, label, due`)
};

const de_qk_has = /** @type {(inputs: Qk_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`parent, children, assignee, label, due`)
};

/**
* | output |
* | --- |
* | "parent, children, assignee, label, due" |
*
* @param {Qk_HasInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const qk_has = /** @type {((inputs?: Qk_HasInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qk_HasInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_qk_has(inputs)
	return en_qk_has(inputs)
});